module.exports = __webpack_public_path__ + "static/img/050602.dda2a043.png";